import React from "react";
import { Fund } from "@/types/Fund";
import { FormValues } from "../FundFormModal/useFundFormModalController";
import { FundFormModal } from "../FundFormModal/FundFormModal";
import { DeleteFundDialog } from "../DeleteFundDialog/DeleteFundDialog";

interface FundsModalsProps {
  isAddFormOpen: boolean;
  isEditFormOpen: boolean;
  isDeleteDialogOpen: boolean;
  selectedFund?: Fund;
  closeModal: (type: "add" | "edit" | "delete", open?: boolean) => void;
  handleFundForm: (values: FormValues, isEdit?: boolean) => Promise<void>;
  handleDeleteFund: (fundId: number) => Promise<void>;
}

export const FundsModals: React.FC<FundsModalsProps> = ({
  isAddFormOpen,
  isEditFormOpen,
  isDeleteDialogOpen,
  selectedFund,
  closeModal,
  handleFundForm,
  handleDeleteFund,
}) => {
  return (
    <>
      {/* Add Fund Modal */}
      <FundFormModal
        open={isAddFormOpen}
        onOpenChange={(open) => closeModal("add", open)}
        onSubmit={async (values) => await handleFundForm(values, false)}
        title="Add Fund"
        description="Create a new fund in the system."
      />

      {/* Edit Fund Modal */}
      <FundFormModal
        open={isEditFormOpen}
        onOpenChange={(open) => closeModal("edit", open)}
        onSubmit={async (values) => {
          await handleFundForm(
            {
              ...selectedFund,
              ...values,
            },
            true
          );
        }}
        fund={selectedFund}
        title="Edit Fund"
        description="Update the fund details."
      />

      {/* Delete Fund Dialog */}
      <DeleteFundDialog
        open={isDeleteDialogOpen}
        onOpenChange={(open) => closeModal("delete", open)}
        onConfirm={handleDeleteFund}
        fund={selectedFund}
      />
    </>
  );
};
